module.exports = __webpack_public_path__ + "img/step29_a_remove_tray.5003e295.png";